import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import I18n from 'i18n-react';
import Autocomplete from 'react-autocomplete';

import './SelectFieldCountry.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  default: PropTypes.string,
  changeValue: PropTypes.func.isRequired
};

const defaultProps = {
  label: '',
  required: false,
  errorMessage: '',
  placeholder: '',
  values: [],
  default: null
};

class SelectFieldCountry extends React.Component {
  constructor(props) {
    super(props);

    const itens = this.props.values.map(this.buildItemValue);

    this.state = {
      isValidState: true,
      values: itens,
      value: props.default ? I18n.translate(this.props.default) : '',
      open: false
    };
  }

  componentWillReceiveProps(props) {
    if (props.default !== null) {
      this.setState({
        value: I18n.translate(props.default)
      });
    }
  }

  buildItemValue(value, index) {
    return {
      id: value,
      label: I18n.translate(value),
      index: index
    };
  }

  getValue(itens, value) {
    return itens.filter(item => item.label.toLowerCase() === value.toLowerCase());
  }

  renderLabel() {
    let label = <Row className="Field__label SelectFieldCountry__emptyLabel" />;

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_selectFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <Row>
        <span
          id={`${this.props.id}_selectFieldIcon`}
          className="SelectFieldCountry__arrow-down"
          onClick={() => {
            this.input.focus();
            this.setState({ open: !this.state.open });
          }}
        />
        <Autocomplete
          className="SelectFieldCountry__select"
          inputProps={{
            id: `${this.props.id}_selectFieldId`,
            placeholder: I18n.translate(this.props.placeholder),
            className: `data-hj-whitelist Field__input SelectFieldCountry__input ${!this.state.isValidState ? 'invalidState' : ''
              }`,
            onClick: () => {
              this.setState({ open: !this.state.open });
            },
            onBlur: event => {
              this.validateField(event.target.value);
            }
          }}
          items={this.state.values}
          getItemValue={item => item.label}
          value={this.state.value}
          renderItem={(item, highlighted) => (
            <li
              key={item.index}
              id={`SelectField-item-${this.props.id}-${item.index}`}
              className={`SelectFieldCountry__selectItem ${highlighted ? 'highlight' : ''}`}>
              <a id={`SelectFieldCountry-link-item-${this.props.id}-${item.index}`}> {item.label}</a>
            </li>
          )}
          onSelect={value => this.validateField(value)}
          selectOnBlur={true}
          renderMenu={this.displayMenu}
          open={this.state.open}
          ref={ref => (this.input = ref)}
        />
      </Row>
    );
  }

  displayMenu(items, value) {
    return (
      <Row className="SelectFieldCountry__menu">
        <Col xs={12}>
          <Row className="SelectFieldCountry__menu-group">
            <Col xs={12}>
              <ul>{items.length > 0 && items}</ul>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_selectFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_selectFieldFooter`} xs={12}>
            <span className="Field__invalidField">
              {I18n.translate(this.state.invalidSelectionMessage || this.props.errorMessage)}
            </span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  invalidateSelection = msgError => {
    const newValue = '';

    this.setState({
      isValidState: false,
      value: newValue,
      invalidSelectionMessage: msgError
    });
    this.props.changeValue(newValue);
  };

  validateField(value) {
    const listValue = this.getValue(this.state.values, value);
    const isValidState = !this.props.required || (this.props.required && listValue.length > 0);
    const newValue = listValue.length > 0 ? listValue[0].label : '';

    this.setState({
      isValidState: isValidState,
      value: newValue,
      open: false,
      invalidSelectionMessage: ''
    });

    this.props.changeValue(newValue);

    return isValidState;
  }

  render() {
    return (
      <div id={this.props.id} className="SelectField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

SelectFieldCountry.propTypes = propTypes;
SelectFieldCountry.defaultProps = defaultProps;

export default SelectFieldCountry;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/selectField/SelectFieldCountry.jsx